export const NAME = 'currentuser';